import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from '@/lib/api';

const BrandingContext = createContext(null);

const DEFAULT = {
  logo_url: '/logo-pemkot-makassar.png',
  favicon_url: '/favicon.png',
  app_name: 'PROAKTIF',
  institution_name: 'Pemerintah Kota Makassar',
  institution_sub: 'Bagian Protokol dan Komunikasi Pimpinan',
  primary_color: '#DC2626',
  accent_color: '#FBBF24',
  motto: 'Sekali Layar Terkembang, Pantang Biduk Surut ke Pantai',
};

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(() => {
    try {
      const cached = localStorage.getItem('proaktif_branding');
      return cached ? JSON.parse(cached) : DEFAULT;
    } catch {
      return DEFAULT;
    }
  });

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get('/branding');
      const merged = { ...DEFAULT, ...data };
      setBranding(merged);
      localStorage.setItem('proaktif_branding', JSON.stringify(merged));
      // Update favicon dynamically
      if (merged.favicon_url) {
        let link = document.querySelector("link[rel='icon']");
        if (!link) {
          link = document.createElement('link');
          link.rel = 'icon';
          document.head.appendChild(link);
        }
        const href = merged.favicon_url.startsWith('/api/')
          ? `${process.env.REACT_APP_BACKEND_URL || ''}${merged.favicon_url}`
          : merged.favicon_url;
        link.href = href;
      }
      // Update document title
      document.title = `${merged.app_name} - ${merged.institution_name}`;
    } catch (e) {
      // ignore
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return (
    <BrandingContext.Provider value={{ ...branding, reload, setBranding }}>
      {children}
    </BrandingContext.Provider>
  );
}

export const useBranding = () => useContext(BrandingContext);
